export default __webpack_public_path__ + "static/media/1.7555ab0a.svg";